import * as actions from '../../redux/actions';

import { KuposButton, KuposInput } from '../../../common';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const ContactForm1 = ({ operator, seeDestinationsButton = false }) => {
  const isExpresoNorto = operator.operator_name === 'expressonorte';

  return (
    <div className="themes-contact-form-1">
      {isExpresoNorto ? (
        <style>
          .themes-contact-form-1 .contact-header{'{'}
          background:
          {operator && operator.color_codes && operator.color_codes.primary_color ? operator.color_codes.primary_color : ''}
          {'}'}
          .themes-contact-form-1 .contact-bottom{'{'}
          background: #fff !important;
        </style>
      ) : (
        <style>
          .themes-contact-form-1 .contact-header{'{'}
          background:
          {operator && operator.color_codes && operator.color_codes.secondary_color
            ? operator.color_codes.secondary_color
            : ''}
        </style>
      )}
      <div className="new-container ">
        {seeDestinationsButton && (
          <div className="d-flex justify-center less-bold-text " style={{ marginBottom: '24px' }}>
            <ExpresoButton operator={operator} text="VER DESTINOS" />
          </div>
        )}
        <div
          className={`contact `}
          style={
            isExpresoNorto
              ? {
                  borderBottomLeftRadius: '10px',
                  borderBottomRightRadius: '10px',
                }
              : {}
          }
        >
          <div className="contact-header">
            <div className="contact-header-text  bold-text font13">CONTÁCTANOS</div>
          </div>
          <div className={`contact-bottom ${isExpresoNorto && 'kupos-border'}`}>
            <div className="align-contact-inputs">
              <div className="contact-input-item">
                <div className="contact-input-label font11">Nombre</div>
                <KuposInput
                  className={isExpresoNorto && 'kupos-border'}
                  type="text"
                  placeholder={isExpresoNorto ? 'Ej. Pedro' : 'Nombre'}
                />
              </div>

              <div className="contact-input-item">
                <div className="contact-input-label font12">Teléfono</div>
                <KuposInput
                  className={isExpresoNorto && 'kupos-border'}
                  type="number"
                  placeholder={isExpresoNorto ? '+56 9 0000 0000' : 'Teléfono'}
                />
              </div>

              <div className="contact-input-item">
                <div className="contact-input-label font12">Email</div>
                <KuposInput
                  className={isExpresoNorto && 'kupos-border'}
                  type="email"
                  placeholder={isExpresoNorto ? 'ejemplo@gmail.com' : 'Email'}
                />
              </div>
            </div>

            <div className="text-area-input">
              <div className="contact-input-label font12">Mensaje</div>
              <textarea
                className="text-area font12"
                style={
                  isExpresoNorto
                    ? {
                        border: '1px solid var(--border-color)',
                      }
                    : {}
                }
                rows={6}
                placeholder={isExpresoNorto ? 'Escribe tu Mensaje aqui' : 'Mensaje'}
              />
            </div>

            <div className="contact-button ">
              {isExpresoNorto ? (
                <ExpresoButton padding={'10px 60px'} operator={operator} text="ENVIAR" />
              ) : (
                <KuposButton className="px-45">ENVIAR</KuposButton>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ExpresoButton = ({ text, operator, padding, onClick }) => {
  return (
    <button
      style={{
        backgroundColor: operator && operator.color_codes ? operator.color_codes.primary_color : '',
        color: 'white',
        border: 'none',
        padding: padding ? padding : '10px 20px',
        borderRadius: '10px',
      }}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm1);



// WEBPACK FOOTER //
// ./src/features/themes/common/contact/ContactForm1.js